<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <validation-observer
        ref="createForm"
        #default="{ invalid }"
      >
        <n-input
          v-model="data"
          :fields="languageFields"
          :init-value="initData"
        />
        <!-- form -->
        <n-form-confirmation
          key="createForm"
          :form="$refs.createForm"
          :disabled="invalid"
          message="alert.areYouSureToTrainData"
          confirm-button-text="button.submit"
          @submit="submit"
        >
          <div class="mb-1">
            <b-card
              v-for="(story, index) in stories"
              :key="genId('story_card_wrapper_', index)"
              class="story-card"
            >
              <div>
                <label class="d-block">
                  {{ $t("field.preTrainMessages") }}
                  <b-icon
                    v-b-tooltip.hover="$t('bot.tooltip.enter_new_conversation')"
                    icon="info-circle-fill"
                    scale="1"
                    variant="normal"
                  />
                </label>
                <div class="d-flex align-items-center mb-1 flex-col">
                  <b-form-group
                    v-for="(k, kIndex) in story"
                    :key="genId('form_wrapper_', kIndex)"
                    class="w-full form-group-container"
                    :label-for="'field.key'"
                  >
                    <div class="w-full">
                      <div class="qa-container">
                        <label class="qa-label">
                          {{ $t("bot.label.human") }}
                        </label>
                        <b-form-input
                          class="w-full"
                          :name="'input-human-' + index + kIndex"
                          :value="k.split('\n')[0]"
                          :placeholder="
                            $t('bot.placeholder.human_message', {
                              suffix: getLangSuffix(data.languageId),
                              text: getLangText(data.languageId),
                            })
                          "
                          @input="
                            (value) => handleHumanInput(value, index, kIndex)
                          "
                        />
                      </div>
                      <div class="qa-container">
                        <label class="qa-label">
                          {{ $t("bot.label.bot") }}
                        </label>
                        <b-form-input
                          class="w-full"
                          :name="'input-bot-' + index + kIndex"
                          :value="k.split('\n')[1]"
                          :placeholder="
                            $t('bot.placeholder.bot_message', {
                              suffix: getLangSuffix(data.languageId),
                              text: getLangText(data.languageId),
                            })
                          "
                          @keyup.enter="handleNewMessage(index, kIndex)"
                          @input="
                            (value) => handleBotInput(value, index, kIndex)
                          "
                        />
                      </div>
                    </div>
                    <div class="group-btn-action">
                      <b-button
                        v-if="stories[index].length > 1"
                        variant="danger"
                        size="sm"
                        @click="handleRemoveInput(index, kIndex)"
                      >
                        -
                      </b-button>
                      <b-button
                        v-if="stories[index].length === kIndex + 1"
                        variant="primary"
                        size="sm"
                        @click="handleAddInput(index, kIndex)"
                      >
                        +
                      </b-button>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div
                v-if="stories.length > 1"
                class="d-flex justify-content-end"
              >
                <b-button
                  class="btn-delete"
                  variant="danger"
                  @click="(e) => handleDeleteStory(e, index)"
                >
                  {{ $t("button.remove") }}
                </b-button>
              </div>
            </b-card>
          </div>
          <div class="dis">
            <div>
              <b-col class="text-left px-0">
                <b-button
                  variant="primary"
                  @click="addField"
                >
                  {{ $t("button.addStory") }}
                </b-button>
              </b-col>
            </div>
          </div>
        </n-form-confirmation>
      </validation-observer>
      <b-row>
        <b-col
          cols="12"
          class="text-right px-0"
        >
          <n-button-loading
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            class="mt-1 mr-1"
            variant="primary"
            :loading="loading"
            :disabled="disabled"
            @submit="save"
          >
            {{ $t("button.trainStory") }}
          </n-button-loading>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormTextarea,
  BFormSelect,
  BFormGroup,
  BFormInput,
  BIcon,
  BIconInfoCircleFill,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading'
import NFormConfirmation from '@/components/NFormConfirmation'
import NInput from '@/components/NInput'
import router from '@/router'
import { v4 as uuidv4 } from 'uuid'
import formInput from './formInput'

const BotRepository = Repository.get('bot')

export default {
  components: {
    BRow,
    BCol,
    BCard,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    BButton,
    BFormTextarea,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BIcon,
    BIconInfoCircleFill,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: [],
      data: {
        messages: null,
        languageId: null,
      },
      loading: false,
      stories: [['']],
      disabled: true,
      selected: null,
      options: [],
      languageFields: [
        {
          key: 'languageId',
          label: 'field.selectLanguage',
          // rules: 'required',
          fakeRequired: true,
          type: 'async-single-selection',
          repository: 'bot',
          selectionKey: 'id',
          selectionLabel: 'translations',
        },
      ],
      listLanguage: [],
      initData: {},
      langDict: {
        en: 'English',
        'zh-cn': '中文',
      },
      globalLangDict: {
        en: '英文留言',
        'zh-cn': '中文信息',
      },
    }
  },
  watch: {
    stories: {
      handler() {
        this.updateDisabled()
      },
      deep: true,
      immediate: true,
    },
    data: {
      handler(v) {
        console.log('selected: ', v)
      },
      deep: true,
    },
  },
  mounted() {
    this.getLanguage()
    this.updateDisabled()
  },
  computed: {
    locale() {
      return this.$i18n.locale.split('-')[0]
    },
  },
  methods: {
    getLangSuffix(languageId) {
      const l = this.langDict[languageId]
      return l?.[this.locale] || l?.en || l?.zh || l?.km || l?.vi || ''
    },
    getLangText(languageId) {
      const l = this.globalLangDict[languageId]
      return l?.[this.locale] || l?.en || l?.zh || l?.km || l?.vi || ''
    },
    genId(text, index) {
      return text + index + uuidv4()
    },
    getLanguage() {
      BotRepository.options()
        .then(response => {
          const { data } = response.data || {}
          this.langDict = data.reduce((acc, item) => {
            acc[item.id] = item.translations
            return acc
          }, {})
          this.globalLangDict = data.reduce((acc, item) => {
            acc[item.id] = item.translations
            return acc
          }, {})
          this.data = {
            languageId: data?.[0]?.id,
            id: data?.[0]?.id,
          }
          this.initData = this.data
        })
        .catch()
    },
    getTrainLanguage() {
      this.loading = true
      BotRepository.trainDataLanguage()
        .then(res => {
          this.options.push(...res?.data)
          this.selected = res?.data?.[0]
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    updateDisabled() {
      const flatStories = this.stories.flat()
      const newStories = this.stories.map(stories => stories.join('\n'))

      let concatStr = ''
      for (const i of newStories) {
        for (const j of i) {
          concatStr += j
        }
        concatStr += '\n'
      }

      let items = concatStr.split('\n')
      items = items.filter(Boolean)

      this.disabled = flatStories.length !== items.length / 2
    },
    submit() {
      console.log('submit................................')
      this.$refs.createForm.validate().then(success => {
        if (success) {
          this.save()
        }
      })
    },
    async save() {
      console.log('save................................')
      const newStories = this.stories.map(stories => stories.join('\n'))
      try {
        this.loading = true
        for (const story of newStories) {
          await BotRepository.create({
            messages: story,
            language: this.data.languageId,
          })
        }
      } catch (error) {
      } finally {
        this.loading = false
        router.push('/bot')
      }
    },
    back() {
      this.$router.back()
    },
    addField() {
      this.stories.push([''])
      // this.updateDisabled();
    },
    handleInput(value, index) {
      this.stories[index] = value
      // this.updateDisabled();
    },
    handleDeleteStory(e, index) {
      e.preventDefault()
      // this.stories.pop();
      this.stories.splice(index, 1)
      this.data = { ...this.data }
      // this.updateDisabled();
    },
    handleNewMessage(index, nestedIndex) {
      if (this.stories[index].length === nestedIndex + 1) {
        this.stories[index].push('')
        // this.updateDisabled();
      }
    },
    handleHumanInput(value, index, nestedIndex) {
      if (value.includes('\n')) {
        value.replaceAll('\n', ' ')
      }

      let text = this.stories[index][nestedIndex]

      if (!text.includes('\n')) {
        text = '\n'
      }

      const texts = text.split('\n')
      this.stories[index][nestedIndex] = `${value}\n${texts[1]}`
      this.updateDisabled()
    },
    handleBotInput(value, index, nestedIndex) {
      if (value.includes('\n')) {
        value.replaceAll('\n', ' ')
      }

      let text = this.stories[index][nestedIndex]

      if (!text.includes('\n')) {
        text = '\n'
      }

      const texts = text.split('\n')
      this.stories[index][nestedIndex] = `${texts[0]}\n${value}`
      this.updateDisabled()
    },
    handleRemoveInput(index, nestedIndex) {
      this.stories[index].splice(nestedIndex, 1)
    },
    handleAddInput(index, nestedIndex) {
      this.handleNewMessage(index, nestedIndex)
    },
  },
  setup() {
    const fields = formInput
    const permissionType = 'manage-users'
    const route = 'bot'

    return {
      fields, permissionType, route,
    }
  },
}
</script>
<style lang="scss">
.dis {
  display: flex;
}

.btn-delete {
  display: flex;
  justify-content: center;
  align-self: flex-end;
  padding: 0;
  border: 0;
  padding: 10px;
}

.story-card.card {
  box-shadow: 0 4px 24px 0 rgba(47, 47, 47, 0.1) !important;
}

.qa-container {
  display: flex;
  align-items: center;
  margin-bottom: 1px;
}

.qa-label {
  width: 100px;
  margin: 0;
}

.w-full {
  width: 100%;
}

.flex-col {
  flex-direction: column;
}

.form-group-container > div {
  align-items: center;
  display: flex;
}

.group-btn-action {
  display: flex;
  gap: 4px;
  padding: 0 0 0 4px;
  width: 40px;
  justify-content: start;
  flex-direction: column;
}
</style>
